import React from "react";
import Loader from "react-loaders";
import "loaders.css/src/animations/square-spin.scss";

export default (props) => <Loader type="square-spin" {...props} />;
